import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RxDragHandleDots2 } from "react-icons/rx";
export default function SortableItem({ datarow, navigate }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: datarow.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className='project-list-items'
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      {/* Entire card is clickable here */}
      <div onClick={() => navigate('/' + datarow.puid)} style={{ cursor: 'pointer' }}>
        <table  style={{ width: '100%' }}>
          <tbody>
            <tr>
               <td style={{width: '22px', height: '25px' }}>
                <RxDragHandleDots2 title='Drag Up Down' className='move-img' {...listeners} /> 
                <AiOutlineFundProjectionScreen className='icon-img' {...listeners} />  
              </td>
               
              <td>
                <div style={{ width: '100%' }}>
                  <div className="title-text">
                    {datarow.projectname?.substring(0, 150)}
                  </div>
                </div>
              </td>
              <td style={{ width: '30px', textAlign: 'center' }}>
                <div className="alert-text">1</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
